/**
 * Dữ liệu mẫu của màn Quản lý nhiệm vụ cho `?mock=` và `pnpm dev` không có backend: danh bạ (phòng
 * ban, người) và một cây nhiệm vụ nhỏ có đủ trạng thái (chưa bắt đầu, đang làm, sắp đến hạn, quá hạn,
 * xong). Không quyết màu ở đây (CLAUDE.md): bảng tông nằm ở `modules/xu-ly-van-ban/constants.ts`.
 */
import type {
  DonViDanhBa,
  GoiYViecCon,
  HoatDong,
  NguoiDanhBa,
  NguoiThamGia,
  TrangThaiNhiemVu,
} from '../modules/xu-ly-van-ban/types-nhiem-vu';

/** Người đang đăng nhập ở bản giả. */
export const MOCK_TOI = { id: 'u-toi', name: 'Lê Minh Quân' };

export const MOCK_DON_VI_DANH_BA: DonViDanhBa[] = [
  { id: 'pb-vp', name: 'Văn phòng Sở', parent_id: null, level: 0 },
  { id: 'pb-kh', name: 'Phòng Kế hoạch - Tài chính', parent_id: null, level: 0 },
  { id: 'pb-cntt', name: 'Phòng Công nghệ thông tin', parent_id: null, level: 0 },
  { id: 'pb-ht', name: 'Tổ Hạ tầng', parent_id: 'pb-cntt', level: 1 },
];

export const MOCK_NGUOI_DANH_BA: NguoiDanhBa[] = [
  { id: 'u-toi', full_name: 'Lê Minh Quân', email: null, avatar_url: null, organization_ids: ['pb-vp'] },
  { id: 'u-an', full_name: 'Nguyễn Văn An', email: null, avatar_url: null, organization_ids: ['pb-cntt'] },
  { id: 'u-binh', full_name: 'Trần Thị Bình', email: null, avatar_url: null, organization_ids: ['pb-kh'] },
  { id: 'u-cuong', full_name: 'Phạm Quốc Cường', email: null, avatar_url: null, organization_ids: ['pb-ht'] },
  { id: 'u-dung', full_name: 'Hoàng Thu Dung', email: null, avatar_url: null, organization_ids: ['pb-vp'] },
];

/** Bản ghi phẳng như bảng `van_ban_task`; cây dựng ở repository. */
export interface BanGhiNhiemVu {
  id: string;
  parent_id: string | null;
  title: string;
  description: string | null;
  related_document: string | null;
  attachment_filename: string | null;
  deadline: string | null;
  status: TrangThaiNhiemVu;
  lead_org_id: string | null;
  lead_org_name: string | null;
  created_by_id: string | null;
  created_by_name: string | null;
  completed_at: string | null;
  progress: number;
  created_at: string;
  updated_at: string;
  participants: NguoiThamGia[];
}

function ngaySau(so: number): string {
  const d = new Date();
  d.setDate(d.getDate() + so);
  return d.toISOString().slice(0, 10);
}

function luc(so: number): string {
  const d = new Date();
  d.setDate(d.getDate() + so);
  return d.toISOString();
}

const nguoi = (id: string, uid: string, role: NguoiThamGia['role']): NguoiThamGia => {
  const u = MOCK_NGUOI_DANH_BA.find((x) => x.id === uid)!;
  const dv = MOCK_DON_VI_DANH_BA.find((o) => u.organization_ids.includes(o.id));
  return { id, user_id: u.id, user_name: u.full_name, user_email: null, org_id: dv?.id ?? null, org_name: dv?.name ?? null, role };
};

export function mockNhiemVu(): BanGhiNhiemVu[] {
  const chung = {
    related_document: null,
    attachment_filename: null,
    created_by_id: MOCK_TOI.id,
    created_by_name: MOCK_TOI.name,
    completed_at: null,
    progress: 0,
  };
  return [
    {
      ...chung,
      id: 't-1',
      parent_id: null,
      title: 'Triển khai kế hoạch chuyển đổi số năm 2026',
      description: 'Theo Kế hoạch số 12/KH-UBND, hoàn thành trước quý IV.',
      related_document: 'Kế hoạch 12/KH-UBND',
      attachment_filename: 'ke-hoach-12.pdf',
      deadline: ngaySau(20),
      status: 'DANG_THUC_HIEN',
      lead_org_id: 'pb-cntt',
      lead_org_name: 'Phòng Công nghệ thông tin',
      created_at: luc(-10),
      updated_at: luc(-1),
      participants: [nguoi('p-1', 'u-an', 'CHU_TRI'), nguoi('p-2', 'u-binh', 'PHOI_HOP'), nguoi('p-3', 'u-toi', 'XEM_DE_BIET')],
    },
    {
      ...chung,
      id: 't-1-1',
      parent_id: 't-1',
      title: 'Rà soát hiện trạng hạ tầng máy chủ',
      description: null,
      deadline: ngaySau(2),
      status: 'DANG_THUC_HIEN',
      progress: 60,
      lead_org_id: 'pb-ht',
      lead_org_name: 'Tổ Hạ tầng',
      created_at: luc(-9),
      updated_at: luc(-1),
      participants: [nguoi('p-4', 'u-cuong', 'CHU_TRI'), nguoi('p-5', 'u-toi', 'PHOI_HOP')],
    },
    {
      ...chung,
      id: 't-1-2',
      parent_id: 't-1',
      title: 'Lập dự toán kinh phí triển khai',
      description: null,
      deadline: ngaySau(10),
      status: 'HOAN_THANH',
      progress: 100,
      completed_at: luc(-2),
      lead_org_id: 'pb-kh',
      lead_org_name: 'Phòng Kế hoạch - Tài chính',
      created_at: luc(-9),
      updated_at: luc(-2),
      participants: [nguoi('p-6', 'u-binh', 'CHU_TRI')],
    },
    {
      ...chung,
      id: 't-2',
      parent_id: null,
      title: 'Báo cáo tình hình xử lý văn bản quý III',
      description: 'Tổng hợp số liệu từ các phòng.',
      deadline: ngaySau(-3),
      status: 'MOI_PHAN_CONG',
      lead_org_id: 'pb-vp',
      lead_org_name: 'Văn phòng Sở',
      created_at: luc(-15),
      updated_at: luc(-15),
      participants: [nguoi('p-7', 'u-toi', 'CHU_TRI'), nguoi('p-8', 'u-dung', 'PHOI_HOP')],
    },
    {
      ...chung,
      id: 't-3',
      parent_id: null,
      title: 'Cập nhật quy chế tiếp nhận văn bản điện tử',
      description: null,
      deadline: null,
      status: 'HOAN_THANH',
      progress: 100,
      completed_at: luc(-4),
      lead_org_id: null,
      lead_org_name: null,
      created_at: luc(-30),
      updated_at: luc(-4),
      participants: [nguoi('p-9', 'u-toi', 'CHU_TRI')],
    },
  ];
}

export function mockHoatDong(): Record<string, HoatDong[]> {
  return {
    't-1-1': [
      {
        id: 'a-2',
        kind: 'PROGRESS',
        actor_id: 'u-cuong',
        actor_name: 'Phạm Quốc Cường',
        content: 'Đã kiểm kê xong 12/20 máy chủ.',
        from_status: null,
        to_status: null,
        progress: 60,
        attachment_filename: null,
        created_at: luc(-1),
      },
      {
        id: 'a-1',
        kind: 'CREATED',
        actor_id: MOCK_TOI.id,
        actor_name: MOCK_TOI.name,
        content: null,
        from_status: null,
        to_status: null,
        progress: null,
        attachment_filename: null,
        created_at: luc(-9),
      },
    ],
  };
}

/** Gợi ý phân rã cố định của bản giả: một phòng ban và một cá nhân khớp danh bạ. */
export function mockGoiYPhanRa(han: string): GoiYViecCon[] {
  return [
    { title: 'Rà soát yêu cầu và phạm vi công việc', assignee_name: 'Tổ Hạ tầng', assignee_type: 'PHONG_BAN', assignee_parent_name: null, processing_unit_id: null, role: 'CHU_TRI', deadline: han },
    { title: 'Tổng hợp kết quả, dự thảo báo cáo', assignee_name: 'Trần Thị Bình', assignee_type: 'CA_NHAN', assignee_parent_name: 'Phòng Kế hoạch - Tài chính', processing_unit_id: null, role: 'PHOI_HOP', deadline: han },
  ];
}

/** Câu lỗi của bản giả, cùng câu backend trả về. */
export const MOCK_CAU_NHIEM_VU = {
  khongThay: 'Nhiệm vụ không tồn tại',
  conViecCon: 'Còn {{so}} nhiệm vụ con chưa hoàn thành',
  khongCoTep: 'Không có tệp đính kèm',
  hanVuot: 'Hạn của "{{ten}}" vượt hạn nhiệm vụ cha',
  tepMau: 'Tệp mẫu của bản giả lập.',
  chuaRoDonVi: 'Chưa xác định đơn vị',
} as const;
